<template>
  <a-modal title="历史版本配方原料对比" width="960px" :visible="visible" :forceRender="true" :destroyOnClose="true" @cancel="cancel" @ok="cancel">
    <template slot="footer">
      <a-button key="back" disabled style="position:absolute;left:20px">
        导出
      </a-button>
      <a-button key="submit" type="primary" @click="cancel">
        关闭
      </a-button>
    </template>
    <div style="display:flex;">
      <div style="wordwrap:nowrap;display:block;width:100px">对比参数:</div>
      <a-checkbox-group v-model="checkedColumns">
        <a-col v-for="item in checkable" :key="item.dataIndex" :span="4">
          <a-checkbox :value="item" :checked="true">
            {{ item.title }}
          </a-checkbox>
        </a-col>
      </a-checkbox-group>
    </div>
    <a-table :row-key="record => record.id" :data-source="records" :loading="loading" :pagination="false" :scroll="{ y: 500 }" bordered>
      <a-table-column title="原料名称" data-index="title" align="center" :width="200"> </a-table-column>
      <a-table-column title="参数" data-index="prop" :width="100" align="center"> </a-table-column>
      <a-table-column data-index="col0" :width="240" align="center">
        <div slot="title" v-if="ary[0]&&ary[0].factoryName" style="line-height:45px;">
          {{ `${ary[0].factoryName}:` }} <span style="color: #1890ff">{{ `${ary[0].formulaName}` }}</span>
        </div>
      </a-table-column>
      <a-table-column data-index="col1" align="center" :width="240">
        <div slot="title" v-if="ary[1]&&ary[1].factoryName">
          {{ `${ary[1].factoryName}:` }} <span style="color: #1890ff">{{ `${ary[1].formulaName}` }}</span>
        </div>
      </a-table-column>
      <a-table-column title="差异" align="center" :width="100" v-slot="scope">
        <div v-if="scope.col0 === scope.col1">-</div>
        <div v-else-if="isNaN(scope.col0) && isNaN(scope.col1)">-</div>
        <div v-else-if="(scope.col0 == 0.00) && (isNaN(scope.col1))">-</div>
        <div v-else-if="(scope.col1 == 0.00) && (isNaN(scope.col0))">-</div>
        <div v-else-if="!isNaN(scope.col0) && isNaN(scope.col1)" style="color:green">{{ `↓${scope.col0}` }}</div>
        <div v-else-if="isNaN(scope.col0) && !isNaN(scope.col1)" style="color:red">{{ `↑${scope.col1}` }}</div>
        <div v-else-if="scope.col0 - scope.col1 < 0" style="color:red">{{ `↑${(scope.col1 - scope.col0).toFixed(3)}` }}</div>
        <div v-else style="color:green">{{ `↓${(scope.col0 - scope.col1).toFixed(3)}` }}</div>
      </a-table-column>
    </a-table>
  </a-modal>
</template>
<script>
import { coreMixins } from '@/Utils/core'
import { modelMixins } from '@/components/Model/unitls.js'
import { columns } from '../config'
export default {
  mixins: [coreMixins, modelMixins],
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    ary: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  data() {
    return {
      indeterminate: false,
      checkAll: true,
      checkable: columns.filter(item => item.checkable),
      checkedColumns: columns.filter(item => item.checked)
    }
  },
  computed: {
    records() {
      const obj = {}
      this.ary && this.ary.forEach((item, index) => {
        item.children&&item.children.forEach(itm => {
          if (!obj[itm.rawName]) {
            obj[itm.rawName] = [itm.rawName]
          }
          obj[itm.rawName][index + 1] = itm
        })
      })
      const result = Object.values(obj).map(([title, col0, col1]) => {
        const materials = []
        this.checkedColumns.forEach((item, i) => {
          const value0 = col0 ? col0[item.dataIndex] : null
          const value1 = col1 ? col1[item.dataIndex] : null
          materials.push({
            title: i == 0 ? title : '',
            prop: item.title,
            id: title + item.title,
            col0: value0 !== null && value0 !== undefined ? (value0.toFixed ? value0.toFixed(3) : value0) : '--',
            col1: value1 !== null && value1 !== undefined ? (value1.toFixed ? value1.toFixed(3) : value1) : '--',
            diff: ''
          })
        })
        return materials
      })
      return result.flat()
    }
  },
  watch: {
    checkedColumns(val) {
      this.indeterminate = !!val.length && val.length < this.checkable.length
      this.checkAll = val.length === this.checkable.length
    },
    ary() {
      this.checkedColumns = columns.filter(item => item.checked)
    }
  },
  methods: {
    onCheckAllChange(e) {
      Object.assign(this, {
        checkedColumns: e.target.checked ? this.checkable : [],
        indeterminate: false,
        checkAll: e.target.checked
      })
    },
    cancel() {
      this.$emit('update:visible', false)
    }
  }
}
</script>
